import { motion } from "framer-motion";
import { Check, ArrowUpRight } from "lucide-react";
import { SERVICES, waLink } from "../data/content";

export const Services = () => (
  <section id="layanan" data-testid="services-section" className="relative py-28 lg:py-36 bg-slatewarm border-y border-white/5">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
        <div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="font-mono-arch text-[11px] tracking-[0.35em] uppercase text-brass mb-5"
          >
            Layanan
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
            className="font-serif-lux font-light text-3xl sm:text-4xl lg:text-5xl text-bone tracking-tight leading-[1.12]"
          >
            Empat lini keahlian,<br />satu standar presisi.
          </motion.h2>
        </div>
        <motion.a
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          data-testid="services-whatsapp-btn"
          href={waLink("Halo PT Raditya Konstruksi, saya ingin bertanya tentang layanan Anda.")}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-2 font-mono-arch text-[11px] tracking-[0.22em] uppercase text-gold hover:text-bone transition-colors"
        >
          Diskusikan Kebutuhan Anda
          <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={1.8} />
        </motion.a>
      </div>

      <div className="mt-16 grid md:grid-cols-2 gap-5">
        {SERVICES.map((s, i) => (
          <motion.div
            key={s.no}
            data-testid={`service-card-${s.no}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: i * 0.12 }}
            className="group relative bg-surface border border-white/5 hover:border-[rgba(197,160,89,0.4)] p-8 lg:p-10 transition-colors duration-500"
          >
            <div className="flex items-start justify-between">
              <p className="font-mono-arch text-xs tracking-[0.3em] text-brassmuted">{s.no}</p>
              <p className="font-mono-arch text-[10px] tracking-[0.2em] uppercase text-dim">{s.subtitle}</p>
            </div>
            <h3 className="font-serif-lux text-2xl lg:text-3xl text-bone mt-6 group-hover:text-gold transition-colors duration-500">
              {s.title}
            </h3>
            <p className="text-sm text-ash font-light leading-relaxed mt-4">{s.description}</p>
            <ul className="mt-6 space-y-2.5">
              {s.points.map((p) => (
                <li key={p} className="flex items-center gap-3 text-sm text-ash/90 font-light">
                  <Check className="w-3.5 h-3.5 text-brass shrink-0" strokeWidth={2.2} />
                  {p}
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
